import { Dropdown, FluentProvider } from '@fluentui/react-components';
import { useActiveTheme } from '../../theme/ThemeContext';
import { useOtherInfoContext } from '../OtherInfoContext';
import { LookupOptions } from '../LookupOptions';
import { FieldWrapper } from './FieldWrapper';
import type { FieldComponentProps } from './types';

interface LookupFieldProps extends FieldComponentProps {
  metadata: any;
  allOptionsObj: any;
}

export const LookupField = ({
  field,
  fieldValue,
  isFieldDisabled,
  validationMessage,
  metadata,
  allOptionsObj,
}: LookupFieldProps) => {
  const { handleOtherInfoChange } = useOtherInfoContext();
  const theme = useActiveTheme();

  const selectedLookupOptions = field.multiSelect
    ? (fieldValue ?? '|').toString().split('|').filter(Boolean)
    : [];

  // Always a string: an undefined value would make Fluent treat the dropdown
  // as uncontrolled, and it then ignores the label once the options load.
  const lookupDisplayValue: string = field.multiSelect
    ? selectedLookupOptions
        .map((optionKey: any) =>
          allOptionsObj.current
            ? allOptionsObj.current[`${field.lookupList}_${optionKey}`]
            : optionKey
        )
        .filter(Boolean)
        .join(', ')
    : allOptionsObj.current?.[`${field.lookupList}_${fieldValue}`] ?? '';

  return (
    <FieldWrapper field={field} validationMessage={validationMessage}>
      <FluentProvider theme={theme} style={{ width: '100%' }}>
        <Dropdown
          style={{ minWidth: 'auto', width: '100%' }}
          multiselect={field.multiSelect}
          selectedOptions={selectedLookupOptions}
          value={lookupDisplayValue}
          onOptionSelect={(_, option) => {
            let value = option?.optionValue?.toString();
            if (field.multiSelect) {
              value = option?.selectedOptions.join('|');
            }
            handleOtherInfoChange(field.name, value);
          }}
          disabled={isFieldDisabled}
        >
          <LookupOptions metadata={metadata} field={field} />
        </Dropdown>
      </FluentProvider>
    </FieldWrapper>
  );
};
